import { render, staticRenderFns } from "./InternationalPhone.vue?vue&type=template&id=6f2fec71&"
import script from "./InternationalPhone.vue?vue&type=script&lang=ts&"
export * from "./InternationalPhone.vue?vue&type=script&lang=ts&"
import style0 from "./InternationalPhone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports